"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkflowMenuButton = void 0;
const react_1 = __importStar(require("react"));
const core_1 = require("@material-ui/core");
const core_ui_1 = require("@sierralabs/core-ui");
const useDeleteWorkflow_1 = require("../hooks/useDeleteWorkflow");
const useUpdateWorkflow_1 = require("../hooks/useUpdateWorkflow");
const WorkflowMenuButton = props => {
    const { workflow, onChange } = props;
    const onChangeRef = (0, react_1.useRef)(onChange);
    const [openConfirmDialog, setOpenConfirmDialog] = (0, react_1.useState)(false);
    const [anchorEl, setAnchorEl] = (0, react_1.useState)(null);
    const { data: updatedWorkflow, updateWorkflow } = (0, useUpdateWorkflow_1.useUpdateWorkflow)(workflow.id);
    const { data: deletedWorkflow, deleteWorkflow } = (0, useDeleteWorkflow_1.useDeleteWorkflow)(workflow.id);
    (0, react_1.useEffect)(() => {
        onChangeRef.current = onChange;
    }, [onChange]);
    (0, react_1.useEffect)(() => {
        var _a;
        if (updatedWorkflow || deletedWorkflow) {
            (_a = onChangeRef.current) === null || _a === void 0 ? void 0 : _a.call(onChangeRef);
        }
    }, [updatedWorkflow, deletedWorkflow]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(core_1.IconButton, { size: 'small', onClick: event => {
                event.preventDefault();
                setAnchorEl(event.currentTarget);
            } },
            react_1.default.createElement(core_1.Icon, { className: 'more-icon' }, "more_vert")),
        react_1.default.createElement(core_1.Menu, { id: 'workflow-more-menu', open: !!anchorEl, anchorEl: anchorEl, getContentAnchorEl: null, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, transformOrigin: { vertical: 'top', horizontal: 'left' }, onClose: () => setAnchorEl(null) },
            react_1.default.createElement(core_1.MenuItem, { onClick: () => {
                    setAnchorEl(null);
                    (workflow === null || workflow === void 0 ? void 0 : workflow.isDeleted)
                        ? updateWorkflow({ isDeleted: false })
                        : setOpenConfirmDialog(true);
                } }, (workflow === null || workflow === void 0 ? void 0 : workflow.isDeleted) ? 'Undelete Workflow' : 'Delete Workflow')),
        react_1.default.createElement(core_ui_1.ConfirmDialog, { open: openConfirmDialog, title: 'Delete Workflow', message: `Are you sure you want to delete the "${workflow.name}" workflow? `, confirmLabel: 'Delete', onCancel: () => setOpenConfirmDialog(false), onConfirm: () => {
                setOpenConfirmDialog(false);
                deleteWorkflow();
            } })));
};
exports.WorkflowMenuButton = WorkflowMenuButton;
exports.default = exports.WorkflowMenuButton;
//# sourceMappingURL=WorkflowMenuButton.js.map